import { Typography } from '@mui/material';
import SvgIcon from '@mui/material/SvgIcon';
import { DialogStyle } from './style';

type AccountLinkedinDialogErrorProps = {
  message: string,
  Icon: typeof SvgIcon,
}
  
export default function AccountLinkedinDialogError({
  message,
  Icon,
}:AccountLinkedinDialogErrorProps): JSX.Element {
  return (
    <Typography
      style={ DialogStyle.errorMessage.style }
      sx={ DialogStyle.errorMessage.sx }
    >
      <Icon style={  DialogStyle.brokenImage } />
      { message }
    </Typography>
  );
}
